<template>
  <v-container class="pa-0">
    <h1 class="text-accent">
      {{ $t('Home.Welcome') }}
    </h1>
    <div class="mt-2 mb-12">
      {{ $t('Home.Message') }}
    </div>

    <SettingPersonal home />
  </v-container>
</template>

<script>
  import SettingPersonal from '@/components/pages/SettingPersonal'

  export default {
    components: {
      SettingPersonal
    },
    props: {},
    data: () => ({
      users: []
    }),
    computed: {},
    watch: {},
    created () {},
    mounted () {},
    methods: {}
  }
</script>
